import NewAuthLayout from '../layout/Layout';
import TenantLogin from '../Components/TenantLogin';
import { useState } from 'react';

interface LoginProps {
	isAdminLogin: boolean;
}

export default function Login({ isAdminLogin }: LoginProps) {
	const [showResetPassModal, setShowResetPassModal] = useState(false);

	return (
		<NewAuthLayout
			variant={'split'}
			showPortalBtn={isAdminLogin}
			showResetPassModal={showResetPassModal}
			setShowResetPassModal={setShowResetPassModal}
		>
			{!isAdminLogin && (
				<TenantLogin setShowResetPassModal={setShowResetPassModal} />
			)}
		</NewAuthLayout>
	);
}
